import { Injectable } from '@angular/core';
import { FormEntryService } from '../../../../../../core/services/form-entry/form-entry.service';
import { ApplicationDeletionService } from '../../../../shared/services/application-deletion/application-deletion.service';
import { ApplicationStateService } from '../../../../shared/services/application-state/application-state.service';
import { StepNavigationService } from '../../../../shared/services/step-navigation/step-navigation.service';
import { ApplicationTemplateFormDialogService } from '../../../../template/shared/services/application-template-form-dialog/application-template-form-dialog.service';
import { ApplicationEventActionService } from '../../../../shared/services/application-event-action/application-event-action.service';
import { ApplicationFormControlManagerService } from '../../../../shared/services/application-form-control-manager/application-form-control-manager.service';
import { ApplicationSubmitToFccService } from '../../../../shared/services/application-submit-to-fcc/application-submit-to-fcc.service';
import { ApplicationSubmitToPscaService } from '../application-submit-to-psca/application-submit-to-psca.service';
import { ReturnRouteService } from '../../../../../../core/services/navigation/return-route.service';

@Injectable({
    providedIn: 'root',
})
export class ApplicationPageFacadeService {
    /**
     * A facade service that centralizes access to core application page services.
     *
     * This service simplifies the dependency injection requirements for child components
     * that extend ApplicationPageBaseComponent by providing a single injection point
     * instead of requiring each component to inject multiple services individually.
     *
     * WARNING: This facade should only include services that are genuinely needed across
     * multiple application page components. Adding service dependencies here affects all
     * derived components and increases coupling. Before adding new services, consider:
     *
     * 1. Is this service needed by most/all application pages?
     * 2. Could this service be injected directly only where needed?
     * 3. Does this service represent core application page functionality?
     *
     * For feature-specific or specialized services, prefer direct injection in the
     * components that need them rather than expanding this facade.
     */
    constructor(
        public readonly formEntryService: FormEntryService,
        public readonly stepNavigationService: StepNavigationService,
        public readonly applicationActionService: ApplicationEventActionService,
        public readonly applicationStateService: ApplicationStateService,
        public readonly applicationDeletionService: ApplicationDeletionService,
        public readonly applicationTemplateFormDialogService: ApplicationTemplateFormDialogService,
        public readonly applicationFormControlManager: ApplicationFormControlManagerService,
        public readonly applicationSubmitToFccService: ApplicationSubmitToFccService,
        public readonly applicationSubmitToPscaService: ApplicationSubmitToPscaService,
        public readonly returnRouteService: ReturnRouteService,
    ) {}
}
